import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// THUNKS
// Ottiene la lista di tutti gli account
export const getAllAccounts = createAsyncThunk(
    'accounts/getAllAccounts',
    async (token, { rejectWithValue }) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/accounts`;
        const headers = {
            'Content-Type': 'application/json',
            'auth-token': token
        };
        const options = { method: 'GET', headers };
        
        const response = await fetch(url, options);
        
        if (!response.ok) {
            const error = await response.json();
            console.error('getAllAccounts - error:', error);
            return rejectWithValue({
                message: error.message || `Errore sconosciuto.`
            })
        }
        const result = await response.json();
        return result
    } catch (error) {
        console.error('getAllAccounts - catch error:', error);
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})

// Ottiene i dettagli di un account specifico
export const getAccountDetails = createAsyncThunk(
    'accounts/getAccount',
    async ({ accountId, token }, { rejectWithValue, dispatch }) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/accounts?accountId=${accountId}`;
        const headers = {
            'Content-Type': 'application/json',
            'auth-token': token
        };
        const options = { method: 'GET', headers };
        
        const response = await fetch(url, options);
        
        if (!response.ok) {
            const error = await response.json();
            console.error('getAccountDetails - error:', error);
            
            // Controllo se l'errore è relativo al token scaduto
            if (error.message && (error.message.includes('jwt expired') || error.message.includes('token'))) {
                console.error('Token JWT scaduto. Reindirizzamento alla pagina di login...');
                
                // Rimuovo direttamente i dati di autenticazione dal localStorage
                localStorage.removeItem('installamelo-auth-user');
                localStorage.removeItem('installamelo-auth-token');
                
                // Forza il reindirizzamento alla pagina di login
                setTimeout(() => {
                    window.location.replace('/login');
                }, 100);
            }
            
            return rejectWithValue({
                message: error.message || `Errore sconosciuto.`
            })
        }
        const result = await response.json();
        return result
    } catch (error) {
        console.error('getAccountDetails - catch error:', error);
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})

// Ottiene info ambiente (test o produzione)
export const getEnvInfo = createAsyncThunk(
    'accounts/getEnvInfo',
    async (_, { rejectWithValue }) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/accounts/envInfo`;
        const response = await fetch(url);
        if (!response.ok) return rejectWithValue({ isTestEnv: false });
        const result = await response.json();
        return result;
    } catch (error) {
        return rejectWithValue({ isTestEnv: false });
    }
})

const initialState = {
    data: null,
    allAccounts: [],
    isLoading: false,
    error: null,
    isTestEnv: false
};

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        clearAccountData: (state) => {
            state.data = null;
            state.error = null;
        },
        setCurrentAccount: (state, action) => {
            state.data = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountDetails.pending, (state)=> {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAccountDetails.fulfilled, (state, action) => {
                state.data = action.payload;
                state.error = null
                state.isLoading = false;
                
            })
            .addCase(getAccountDetails.rejected, (state, action) => {
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento dei dati dell'account.";
                state.isLoading = false;
            })
            .addCase(getAllAccounts.pending, (state)=> {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllAccounts.fulfilled, (state, action) => {
                state.allAccounts = action.payload;
                state.error = null
                state.isLoading = false;
            })
            .addCase(getAllAccounts.rejected, (state, action) => {
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento della lista degli account.";
                state.isLoading = false;
            })
            .addCase(getEnvInfo.fulfilled, (state, action) => {
                state.isTestEnv = action.payload?.isTestEnv || false;
            })
    }
})

// Selectors
export const selectAccountData = (state) => state.account.data;
export const selectAllAccounts = (state) => state.account.allAccounts;
export const selectAccountLoading = (state) => state.account.isLoading;
export const selectAccountError = (state) => state.account.error;
export const selectIsTestEnv = (state) => state.account.isTestEnv;

export const {clearAccountData, setCurrentAccount} = accountSlice.actions;
export default accountSlice.reducer;
